import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { BrowserRouter } from "react-router";
// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";
import App from './00_global/scripts/App';
import * as serviceWorker from './00_global/scripts/serviceWorker';
import { developmentData } from './01_fundaments/utilities/localOverwrites';
import {useNativeCallbackIfPresent} from "./01_fundaments/utilities/nativeCallback";


const root = createRoot(document.getElementById('root'));

// Sentry.init({
// 	dsn: "https://c0befef8d74946bd8fe7b0e80144107d@o389537.ingest.sentry.io/5227812",
// 	release: `OIDC@${import.meta.env.REACT_APP_BUILD}`,
// 	integrations: [
// 		new Integrations.BrowserTracing(),
// 	],
// 	tracesSampleRate: 0.1,
// });

// development mode - set dummy backendData
if (import.meta.env.DEV) {
	window.backendData = JSON.parse(JSON.stringify(developmentData));
}

// function appLoaded() {
// 	document.documentElement.classList.add('app-loaded');
// }

// render the app
root.render(
	<BrowserRouter basename="/">
		<App />
	</BrowserRouter>,
	// document.getElementById("root"),
	// appLoaded
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
